<template>
    <div class="content-full-h" ref="image-editor" @mousemove="mousePosition($event)" :style="backgroundStyle">
        <div class="tools">
            <input-text placeholder="Zoom" :value="(imageData.zoom * 100).toFixed(0)" @change="zoomChange" after="%"/>
            <btn square @click="zoomChange(imageData.zoom * 100 + 5)">
                <i class="fal fa-search-plus"></i>
            </btn>
            <btn square @click="zoomChange(imageData.zoom * 100 - 5)">
                <i class="fal fa-search-minus"></i>
            </btn>
            <btn square @click="zoomChange(100)">
                <tooltip :text="$t('Reset zoom')" position="left" delay="0.5s">
                    <i class="fal fa-ban"></i>
                </tooltip>
            </btn>
        </div>
        <div class="editable-image" ref="image-editor-content"
             :class="{'drag':drag,'move':moveKeyPress,'draw':interactiveImage.labelIsDraw()}"
             :style="{top:imageData.top+'px',left:imageData.left+'px',width:imageData.width+'px', height:imageData.height+'px'}"
             @wheel="mouseZoom"
             @mousedown="startMoveWorkspace($event)"
             @mouseup="stopMoveWorkspace()"
            >
            <img
                v-for="(image,z) in interactiveImage.chapterGetImages()"
                :key="z"
                :src="image"
                alt=""
                class="image-list"
                ref="image-content"
                :style="'z-index:'+(z+1)"
                @click="resetSelect"
                v-if="image"/>
            <svg class="label-svg" v-if="imgLoaded"
                 @click="mouseClick"
            >
                <rect x="0" y="0" width="100%" height="100%" fill="rgba(0,0,0,0.08)"
                      @click="resetSelect()"/>
                
                <InteractiveImage_Labels_Pointer
                    v-for="label in interactiveImage.labelsGetReverse()"
                    :key='label.getObjectType()+""+label.getId()'
                    :label="label"
                    :imageData="imageData"
                    @drag="drag = true; initImage()"
                    @undrag="drag = false"
                    @edit="interactiveImage.labelEdit(label)"
                    @select="interactiveImage.labelSelect(label)"
                />
                <defs>
                    <filter id="shadow">
                        <feDropShadow dx="0" dy="0" stdDeviation="2"/>
                    </filter>
                </defs>
            </svg>
        </div>
    </div>
</template>

<script>
import InteractiveImage_Labels_Pointer from "./InteractiveImage_Label_Pointer";
import Tools from "../../class/tools"
import {interactiveImage} from "@/class/interactive-image/interactiveImage";
import events from "@/events/events";
import InputText from "@/modules/input/input-text";
import Btn from "@/modules/buttons/btn";
import Tooltip from "@/modules/tooltip";

export default {
    name: "InteractiveImage_Content",
    components: {Tooltip, Btn, InputText, InteractiveImage_Labels_Pointer},
    props: {
        interactiveImage: {type: Object, default: () => new interactiveImage()},
        loading: {type: Boolean, default: false},
    },
    data() {
        return {
            mouse: {
                x: 0,
                y: 0,
            },
            imageData: {
                x: 0,
                y: 0,
                w: 0,
                h: 0,
                left: 0,
                top: 0,
                width: 0,
                height: 0,
                zoom: 1,
                zoomLeft: 0,
                zoomTop: 0,
                imgWidth:0,
                imgHeight:0,
            },
            imgDataEditor: {},
            currentLabels: [],
            drag: false,
            move: false,
            moveKeyPress: false,
            movePrev: null,
            imgLoaded: false,
            draw:false,
            width:this.interactiveImage.width,
            height:this.interactiveImage.height,
        }
    },
    created() {
        window.addEventListener('keydown', this.moveKeyDown);
        window.addEventListener('keyup', this.moveKeyUp);
    },
    destroyed() {
        window.removeEventListener("keydown", this.moveKeyDown);
        window.removeEventListener('keyup', this.moveKeyUp);
    },
    methods: {
        initImage() {
            
            this.imgDataEditor = this.getRenderedSize(true,
                this.$refs["image-editor"].clientWidth,
                this.$refs["image-editor"].clientHeight,
                this.width,
                this.height,
                50);
            
            this.imageData.left = this.imgDataEditor.left + this.imageData.zoomLeft;
            this.imageData.top = this.imgDataEditor.top + this.imageData.zoomTop;
            this.imageData.width = this.imgDataEditor.width;
            this.imageData.height = this.imgDataEditor.height;
            
            // gestion du zoom
            
            this.imageData.width *= this.imageData.zoom;
            this.imageData.height *= this.imageData.zoom;
            
            this.imageData.x = this.$refs["image-editor"].getBoundingClientRect().left;
            this.imageData.y = this.$refs["image-editor"].getBoundingClientRect().top + this.imageData.top;
            this.imageData.ratioX = this.imageData.width / this.width;
            this.imageData.ratioY = this.imageData.height / this.height;
            this.imageData.xImage = this.$refs["image-editor-content"].getBoundingClientRect().left;
            this.imageData.yImage = this.$refs["image-editor-content"].getBoundingClientRect().top;
            
            this.imageData.imgWidth = this.interactiveImage.width;
            this.imageData.imgHeight = this.interactiveImage.height;
            
            this.imgLoaded = true;
            
            console.log("- imageData : ", this.imageData)
        },
        mouseClick(event){
            
            this.initImage();
    
            this.$store.dispatch('updateMouseClickPosition', {
                x: event.pageX - this.imageData.xImage,
                y: event.pageY - this.imageData.yImage
            });
        },
        mousePosition(event) {
            // this.mouse.x = event.pageX - this.imageData.x;
            // this.mouse.y = event.pageY - this.imageData.y;
            
            if (this.move && !this.drag) {
                if (this.movePrev === null) {
                    this.movePrev = {
                        x: event.pageX,
                        y: event.pageY,
                    }
                }
                
                let offsetX = event.pageX - this.movePrev.x;
                let offsetY = event.pageY - this.movePrev.y;
                
                this.imageData.zoomLeft += offsetX
                this.imageData.zoomTop += offsetY;
                
                this.imageData.left = this.imgDataEditor.left + this.imageData.zoomLeft;
                this.imageData.top = this.imgDataEditor.top + this.imageData.zoomTop;
                
                this.movePrev.x = event.pageX;
                this.movePrev.y = event.pageY;
                
                return;
            }
            
            if (this.drag || this.interactiveImage.labelIsDraw()) {
                this.$store.dispatch('updateMousePosition', {
                    x: event.pageX - this.imageData.xImage,
                    y: event.pageY - this.imageData.yImage
                });
                
                return;
            }
            
        },
        mouseZoom($event) {
            // if (!this.moveKeyPress) return;
            if(this.blockMouseZoom){
                return
            }
    
            this.blockMouseZoom = true
            
            if ($event.deltaY < 0) {
                this.imageData.zoom = Tools.clamp(this.imageData.zoom + 0.05, 0.3, 5)
            } else {
                this.imageData.zoom = Tools.clamp(this.imageData.zoom - 0.05, 0.3, 5)
            }
            
            let beforeX = ($event.clientX - this.imageData.xImage) / this.imageData.width
            let beforeY = ($event.clientY - this.imageData.yImage) / this.imageData.height
            
            let prevWidth = this.imageData.width;
            let prevHeight = this.imageData.height;
            this.imageData.width = this.imgDataEditor.width * this.imageData.zoom;
            this.imageData.height = this.imgDataEditor.height * this.imageData.zoom;
    
            let diffWidth = (this.imageData.width - prevWidth);
            let diffHeight = (this.imageData.height - prevHeight);
            
            let afterX = beforeX + (diffWidth / this.imageData.width)
            let afterY = beforeY + (diffHeight / this.imageData.height)
    
            this.imageData.zoomTop -= diffHeight * afterY
            this.imageData.zoomLeft -= diffWidth * afterX
            this.initImage();
            
            setTimeout(() => {
                this.blockMouseZoom = false
            },20)
            
        },
        zoomChange(val){
            this.imageData.zoom = Tools.clamp(val / 100, 0.5, 5);
            
            this.imageData.width = this.imgDataEditor.width * this.imageData.zoom;
            this.imageData.height = this.imgDataEditor.height * this.imageData.zoom;
    
            this.imageData.zoomTop = (this.imgDataEditor.height - this.imageData.height) / 2
            this.imageData.zoomLeft = (this.imgDataEditor.width - this.imageData.width) / 2
            
            this.initImage();
        },
        moveKeyDown($event) {
            if ($event.keyCode === 16) {
                this.moveKeyPress = true;
            }
        },
        moveKeyUp($event) {
            if ($event.keyCode === 16) {
                this.moveKeyPress = false;
                this.stopMoveWorkspace();
            }
        },
        startMoveWorkspace($event) {
            // if (!this.moveKeyPress) return;
            
            this.move = true;
            this.movePrev = null;
            events.$on("body:click:mouse:up",this.stopMoveWorkspace)
        },
        stopMoveWorkspace($event) {
            this.move = false;
            this.movePrev = null;
            events.$off("body:click:mouse:up",this.stopMoveWorkspace)
        },
        resetDrag($event) {
            this.drag = false;
            this.move = false;
        },
        resetSelect() {
            if(!this.interactiveImage.labelHasEdit()) {
                this.interactiveImage.labelUnselect()
            }
            this.drag = false;
        },
        editLabel(k) {
            this.$emit('edit', k)
        },
        isSelected(k) {
            return this.selected === k;
        },
        isHovered(k) {
            return this.hovered === k;
        },
        
        getRenderedSize(contains, cWidth, cHeight, width, height, pos) {
            let oRatio = width / height,
                cRatio = cWidth / cHeight;
            
            if (contains ? (oRatio > cRatio) : (oRatio < cRatio)) {
                width = cWidth;
                height = cWidth / oRatio;
            } else {
                width = cHeight * oRatio;
                height = cHeight;
            }
            
            let left = (cWidth - width) * (pos / 100);
            let top = (cHeight - height) / 2;
            
            return {
                top: top,
                left: left,
                width: width,
                height: height
            };
        },
    },
    computed:{
        backgroundStyle(){
            if(this.interactiveImage.backgroundColorShow()){
                return "background-color:"+this.interactiveImage.background_color
            }
            return "";
        }
    },
    watch: {
        loading() {
            if (this.loading) {
                this.$vs.loading({
                    container: this.$refs["image-editor"],
                    scale: 0.5
                })
            } else {
                this.$vs.loading.close(this.$refs["image-editor"]);
                this.initImage();
            }
        },
        'interactiveImage.width'(){
            this.width = this.interactiveImage.width;
            this.initImage()
        },
        'interactiveImage.height'(){
            this.height = this.interactiveImage.height;
            this.initImage()
        }
    },
    mounted(){
        events.$on("body:click:mouse:up", this.resetSelect)
    },
    beforeDestroy() {
        events.$off("body:click:mouse:up", this.resetSelect)
    }
}
</script>